import { API_HOST, getHttpDeleteOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = (externalReference) => `${API_HOST}/teams/${externalReference}`;
const getSpecificEndpoint = (teamExternalReference, memberExternalReference) =>
  `${getEndpoint(teamExternalReference)}/members/${memberExternalReference}`;

export const getAddMemberToTeamRequest = (teamExternalReference, memberExternalReference) => [
  getSpecificEndpoint(teamExternalReference, memberExternalReference),
  getHttpPostOptions()
];

export const getRemoveMemberFromTeamRequest = (teamExternalReference, memberExternalReference) => [
  getSpecificEndpoint(teamExternalReference, memberExternalReference),
  getHttpDeleteOptions()
];
